// extracted by mini-css-extract-plugin
export var articleContainer = "BlogArticlesSelectionBannerSection-module--articleContainer--4f1b6";
export var section = "BlogArticlesSelectionBannerSection-module--section--34c5c";
export var swiperSection = "BlogArticlesSelectionBannerSection-module--swiperSection--291e9";